<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getDealer } from "../../../../api"
    import { inquiry } from "../../../../functionTools/offerAssistant"
    import FormInputRadio from "../../../widgets/Form/FormInputRadio.svelte"
    import ChevronDownIcon from "svelte-material-icons/ChevronDown.svelte"
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import { iframeView } from "../../../../functionTools/iframeIntegration"

    let { missingDealer, selectedCountry, submitTried } = $props()
    let active_acc1 = $state(false)
    let active_acc2 = $state(false)
    let dealerChoiceIsLocal = $state(false)
    let range = $state(50)
</script>

<section>
    <p>
        {$_("inquiry.dealer-choice-intro")}
    </p>
    <div class="section_headline" style={missingDealer && submitTried ? "color: var(--error); font-weight: bold" : ""}>
        {$_("inquiry.dealer-choice-prompt")}
    </div>
    <div class="accordeon">
        {#if selectedCountry.show_inquiry_local_store_select && $inquiry.billingAddress?.postcode}
            <div class="acc_item">
                <!-- svelte-ignore a11y_no_static_element_interactions -->
                <div
                    class="acc_trigger"
                    class:active={active_acc1}
                    onclick={() => {
                        active_acc1 = !active_acc1
                        active_acc2 = false
                    }}
                    onkeydown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault()
                            ;(e.target as HTMLElement).click()
                        }
                    }}
                    aria-expanded={active_acc1}
                    aria-label={$_("inquiry.local-dealer")}
                >
                    <h4>{$_("inquiry.local-dealer")}</h4>
                    {#if $inquiry.dealerChoice?.number && dealerChoiceIsLocal}
                        <div class="info chosen">
                            <strong>{$inquiry.dealerChoice.company}</strong>
                        </div>
                    {:else}
                        <div class="info">
                            {$_("inquiry.please-choose")}
                        </div>
                    {/if}
                    <div class="icon">
                        <ChevronDownIcon size="30px" />
                    </div>
                </div>
                {#if active_acc1}
                    <div class="acc_content">
                        {#await getDealer($inquiry.billingAddress.countryCode == "DE" ? { countrycode: $inquiry.billingAddress.countryCode, postcode: $inquiry.billingAddress?.postcode, range } : { countrycode: $inquiry.billingAddress.countryCode })}
                            <BarLoader />
                        {:then data}
                            {#if $inquiry.billingAddress.countryCode == "DE"}
                                {$_("inquiry.within-radius-of")}
                                <div class="radiusChoice">
                                    <div>
                                        <FormInputRadio label="20km" value={20} bind:group={range} />
                                    </div>
                                    <div>
                                        <FormInputRadio label="50km" value={50} bind:group={range} />
                                    </div>
                                    <div>
                                        <FormInputRadio label="100km" value={100} bind:group={range} />
                                    </div>
                                    <div>
                                        <FormInputRadio label="200km" value={200} bind:group={range} />
                                    </div>
                                </div>
                            {/if}
                            <div class="options">
                                {#each data.data || [] as d}
                                    <!-- svelte-ignore a11y_click_events_have_key_events -->
                                    <!-- svelte-ignore a11y_no_static_element_interactions -->
                                    <div
                                        class="option"
                                        onclick={() => {
                                            $inquiry.dealerChoice = Object.assign({}, d, {
                                                number: parseInt(d.number),
                                            })
                                            active_acc1 = false
                                            dealerChoiceIsLocal = true
                                        }}
                                        onkeydown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault()
                                                ;(e.target as HTMLElement).click()
                                            }
                                        }}
                                        aria-expanded={active_acc1}
                                        aria-label={d.company}
                                    >
                                        {d.company}
                                        ({d.distance}km{#if d.city}, {d.city}{/if})
                                    </div>
                                {:else}
                                    {$_("inquiry.no-dealer-within-radius")}
                                {/each}
                            </div>
                        {:catch e}
                            {$_("inquiry.no-dealer-for-postcode")}
                        {/await}
                    </div>
                {/if}
            </div>
            {#if selectedCountry.show_inquiry_online_shop_select}
                <div class="or">{$_("inquiry.or")}</div>
            {/if}
        {/if}
        {#if selectedCountry.show_inquiry_online_shop_select}
            <div class="acc_item">
                <!-- svelte-ignore a11y_no_static_element_interactions -->
                <div
                    class="acc_trigger"
                    class:active={active_acc2}
                    onclick={() => {
                        active_acc2 = !active_acc2
                        active_acc1 = false
                    }}
                    onkeydown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault()
                            ;(e.target as HTMLElement).click()
                        }
                    }}
                    aria-expanded={active_acc2}
                    aria-label={$_("inquiry.renz-online-partner")}
                >
                    <h4>{$_("inquiry.renz-online-partner")}</h4>
                    {#if $inquiry.dealerChoice?.online_shop && !dealerChoiceIsLocal}
                        <div class="info chosen">
                            <strong>{$inquiry.dealerChoice.company}</strong>
                        </div>
                    {:else}
                        <div class="info">
                            {$_("inquiry.please-choose")}
                        </div>
                    {/if}
                    <div class="icon">
                        <ChevronDownIcon size="30px" />
                    </div>
                </div>
                {#if active_acc2}
                    <div class="acc_content">
                        {#await getDealer({ countrycode: $inquiry.billingAddress.countryCode, online: true })}
                            <BarLoader />
                        {:then data}
                            <div class="options">
                                {#each data.data || [] as d}
                                    <!-- svelte-ignore a11y_click_events_have_key_events -->
                                    <!-- svelte-ignore a11y_no_static_element_interactions -->
                                    <div
                                        class="option"
                                        onclick={() => {
                                            $inquiry.dealerChoice = Object.assign({}, d, {
                                                number: parseInt(d.number),
                                            })
                                            active_acc2 = false
                                            dealerChoiceIsLocal = false
                                        }}
                                        aria-expanded={active_acc2}
                                        aria-label={d.company}
                                    >
                                        {d.company}
                                    </div>
                                {:else}
                                    {$_("inquiry.no-dealer-within-radius")}
                                {/each}
                            </div>
                        {/await}
                    </div>
                {/if}
            </div>
        {/if}
    </div>
    {#if $inquiry.customerType === "business"}
        <div class="or">{$_("inquiry.or")}</div>
        <div>
            <label for="">{$_("inquiry.customer-type.desired-retail-partner-label")}</label>
            <textarea
                name="desiredRetailPartner"
                placeholder={$_("inquiry.customer-type.desired-retail-partner-placeholder")}
                rows={$iframeView ? 2 : 5}
                bind:value={$inquiry.desiredRetailPartner}
                onkeyup={() => {
                    if ($inquiry.desiredRetailPartner) {
                        $inquiry.dealerChoice = null
                        active_acc1 = false
                        active_acc2 = false
                    }
                }}
            ></textarea>
        </div>
    {/if}
</section>

<style lang="less">
    @import "../../../../css/variables.less";
    /* Accordeon */
    .accordeon {
        background: var(--comp--input--background);
        color: var(--comp--input--color);

        .or {
            margin: 5px 0px;
        }
        .acc_item {
            position: relative;
            margin-bottom: 0px;

            .acc_trigger {
                border: 1px solid var(--border-color-default);
                .border-radius(5px);
                position: relative;
                cursor: pointer;
                padding: 10px;
                .transition();

                h4 {
                    font-size: 1rem;
                    margin: 0px;
                }
                .info {
                    font-size: 0.8rem;
                    &.chosen {
                        color: var(--primary);
                    }
                }
                .icon {
                    position: absolute;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    font-size: 30px;
                    width: 50px;
                    .flex();
                    align-items: center;
                    justify-content: center;
                    .transition();
                }
                &.active {
                    border-color: var(--primary);
                    .icon {
                        transform: rotate(180deg);
                    }
                }
            }
            .acc_content {
                position: absolute;
                top: 100%;
                width: 100%;
                height: auto;
                margin-top: -10px;
                z-index: 100;
                border-left: solid 1px var(--primary);
                border-right: solid 1px var(--primary);
                border-bottom: solid 1px var(--primary);
                padding: 20px;
                background: var(--comp--input--background);
                color: var(--comp--input--color);

                .options {
                    width: 100%;
                    .option {
                        cursor: pointer;
                        padding: 10px;
                        border-bottom: 1px solid var(--border-color-default);
                        .transition();
                        &:hover {
                            background: var(--comp--input--background-hover);
                        }
                        &:last-child {
                            border: 0;
                        }
                    }
                }
                // display: none;
            }
        }
    }
</style>
